.Dropzone {
  cursor: pointer;
  position: relative;
  border-radius: var(--radius-sm);
  border: 1px solid var(--neutral-3);
  width: 100%;
  background-color: var(--bg);
  padding: var(--space);
  transition:
    border-color 0.1s ease-in-out,
    box-shadow 0.1s ease-in-out;

  .DropzoneDragging {
    position: absolute;
    inset: 0;
    opacity: 0;
    display: grid;
    place-items: center;
    transition: opacity 0.1s ease-in-out;
  }

  .DropzoneContent {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--space-md);
    transition: opacity 0.1s ease-in-out;
  }

  .DropzoneLoading {
    position: absolute;
    inset: 0;
    display: grid;
    place-items: center;
    opacity: 0;
    transition: opacity 0.1s ease-in-out;
  }

  &[data-dragging="true"] {
    cursor: pointer;
    border-color: var(--primary);
    border-style: dashed;

    .DropzoneDragging {
      opacity: 1;
    }

    .DropzoneContent,
    .DropzoneLoading {
      opacity: 0;
    }
  }

  &[data-loading="true"] {
    cursor: not-allowed;
    background-color: var(--bg);
    border-color: var(--neutral-3);
    border-style: dashed;

    .DropzoneDragging,
    .DropzoneContent {
      opacity: 0;
    }

    .DropzoneLoading {
      opacity: 1;
    }
  }

  &:hover:not([data-loading="true"]) {
    border-color: var(--primary);
    box-shadow: var(--smooth-shadow);
  }
}
